import classNames from 'classnames';
import React from 'react';

import Button from 'sharedreact/components/Button';
import LinkWithContext from 'sharedreact/components/LinkWithContext';
import { useIsFormValid } from 'sharedreact/components/ValidationForm';

type Props = {
  id: string,
  className?: string,
  disabled?: boolean,
  type?: string
  icon?: string,
  badgeValue?: React.ReactNode,
  children?: React.ReactNode,
  collapsable?: boolean,
  onlyShowIconWhenCollapsed?: boolean,
  active?: boolean,
  autoFocus?: boolean,
  title?: string,
  to?: string,
  disableOnFormValidationErrors?: boolean
};

function LinkButton ({
  id, className, disabled, to, type = 'btn-default', icon, badgeValue,
  children, collapsable, onlyShowIconWhenCollapsed, active,
  disableOnFormValidationErrors, autoFocus, title }: Props
) {
  const [isFormValid] = useIsFormValid();
  
  const buttonDisabled = !to || disabled || (disableOnFormValidationErrors === true && !isFormValid);

  const buttonClassName = classNames(
    'esko_btn',
    type.split(' ').map(className => 'esko_' + className).join(' '),
    className, {
      active: active
    }
  );

  if (buttonDisabled) {
    return (
      <Button id={id}
        className={className}
        type={type}
        icon={icon}
        badgeValue={badgeValue}
        collapsable={collapsable}
        disabled
        onlyShowIconWhenCollapsed={onlyShowIconWhenCollapsed}
        active={active}
        autoFocus={autoFocus}
        title={title}
      >
        {children}
      </Button>
    );
  }

  if (icon != null) {
    if (collapsable) {
      if (onlyShowIconWhenCollapsed) {
        return (
          <LinkWithContext id={id}
            to={to}
            type='button'
            className={buttonClassName}
            title={title}
          >
            <div className='esko_visible-lg-inline esko_visible-md-inline'>
              {children}
            </div>
            <div className='esko_visible-xs-inline esko_visible-sm-inline'>
              <span className={icon}>
                {badgeValue}
              </span>
            </div>
          </LinkWithContext>
        );
      } else {
        return (
          <LinkWithContext id={id}
            to={to}
            type='button'
            className={buttonClassName}
            title={title}
          >
            <div className='esko_visible-lg-inline esko_visible-md-inline'>
              <span className={icon}>{badgeValue}</span> {children}
            </div>
            <div className='esko_visible-xs-inline esko_visible-sm-inline'>
              <span className={icon}>
                {badgeValue}
              </span>
            </div>
          </LinkWithContext>
        );
      }
    } else {
      return (
        <LinkWithContext id={id}
          to={to}
          type='button'
          className={buttonClassName}
          title={title}
        >
          <span className={icon}>{badgeValue}</span> {children}
        </LinkWithContext>
      );
    }
  } else {
    return (
      <LinkWithContext id={id}
        to={to}
        type='button'
        className={buttonClassName}
        title={title}
      >
        {children}
      </LinkWithContext>
    );
  }
}

export default LinkButton;
